<!-- app/javascript/dashboard/routes/dashboard/kanban/components/ImageLightbox.vue -->
<template>
    <div
      v-if="modelValue"
      class="image-modal"
      @click="close"
    >
      <div class="image-modal__inner" @click.stop>
        <img :src="url" alt="imagem" />
        <button
          type="button"
          class="image-modal__close"
          title="Fechar"
          @click.stop.prevent="close"
        >
          ×
        </button>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'ImageLightbox',
    props: {
      modelValue: { type: Boolean, required: true },
      url: { type: String, default: null },
    },
    emits: ['update:modelValue'],
    mounted() {
      this._onKey = e => { if (e.key === 'Escape') this.close(); };
      window.addEventListener('keydown', this._onKey);
    },
    beforeUnmount() {
      window.removeEventListener('keydown', this._onKey);
    },
    methods: {
      close() {
        this.$emit('update:modelValue', false);
      },
    },
  };
  </script>
